import { FC } from 'react';

export interface DetailPageProps {}

const DetailPage: FC<DetailPageProps> = props => {
  return <div>详情</div>;
};

export default DetailPage;
